export default __webpack_public_path__ + "static/media/list-icon.3d681e47.svg";